module.exports = __webpack_public_path__ + "static/kran04_768-9159d94dcf37df5543d2f661a08e58d6.jpg";